<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">Pedidos</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
        <div class="col-lg-6 col-5 text-right">
          <router-link
            v-if="$can('store', 'orders')"
            :to="{ name: 'OrderCreate' }"
            class="btn base-button btn-neutral btn-sm mt-1"
          >
            Nuevo Pedido
          </router-link>
          <button v-if="campaign" class="btn base-button btn-neutral btn-sm mt-1" @click="campaign = null">
            Cambiar Campaña
          </button>
          <router-link
            v-if="$can('statistics', 'orders')"
            :to="{ name: 'OrdersStatistics' }"
            class="btn base-button btn-neutral btn-sm mt-1"
          >
            Volver a Estadísticas
          </router-link>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div v-if="!campaign" class="row justify-content-center">
        <div class="col-md-6 col-sm-8 col-xs-12 card-wrapper">
          <div class="card mb-4">
            <div class="card-header">
              <h3 class="mb-0">Elija la campaña para listar los pedidos</h3>
            </div>
            <div class="card-body">
              <campaign-select v-model="campaign" />
            </div>
          </div>
        </div>
      </div>

      <div v-if="campaign" class="row">
        <div class="col-sm-12">
          <orders-table
            :filter-campaign="campaign"
            :filter-variety="variety"
            :filter-seller-producers="seller"
            :title="title"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import OrdersTable from './List/OrdersTable';
import CampaignSelect from '@/components/ModelSelects/CampaignSelect';

export default {
  components: {
    RouteBreadCrumb,
    OrdersTable,
    CampaignSelect,
  },

  data() {
    return {
      variety: null,
      campaign: null,
      showDefaultTotals: true,
      seller: null,
      title: 'Pedidos',
    };
  },

  created() {
    this.seller = +this.$route.params.id;
    this.campaign = +this.$route.query.campaign;
    this.variety = +this.$route.query.variety;
    this.fetchSeller();
  },

  methods: {
    fetchSeller() {
      this.$services
        .resource('sellers')
        .show(this.seller)
        .then((res) => res.data.data)
        .then((seller) => (this.title = `Pedidos del Asesor Técnico: ${seller.name}`));
    },
  },
};
</script>

<style scoped>
::v-deep .over-header {
  z-index: 99999;
}
</style>
